module.exports = __webpack_public_path__ + "static/img/__1291.b84cbee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__1291.jpg
// module id = vrPJ
// module chunks = 0